import React, { useMemo, useState } from 'react';

export default function ECGPCalculator() {
  const [gcs, setGcs] = useState(15);
  const [erp, setErp] = useState(0);
  const result = useMemo(() => Math.max(1, Number(gcs) - Number(erp)), [gcs, erp]);

  return (
    <section className="ecgp-calculator" aria-labelledby="ecgp-calc-title">
      <div className="calculator-section__intro">
        <div>
          <span className="section-kicker">Calculadora ECG-P</span>
          <h2 id="ecgp-calc-title">Calcule ECG-P a partir do Glasgow e das pupilas</h2>
        </div>
        <p>ECG-P = ECG total − ERP. O Escore de Reatividade Pupilar varia de 0 a 2.</p>
      </div>

      <div className="ecgp-calc-grid">
        <label className="ecgp-field">
          <span>ECG total (3–15)</span>
          <input type="number" min="3" max="15" value={gcs} onChange={(e) => setGcs(Math.min(15, Math.max(3, Number(e.target.value) || 3)))} />
        </label>

        <fieldset className="ecgp-fieldset">
          <legend>Reatividade pupilar (ERP)</legend>
          {[
            [0, 'Ambas reativas'],
            [1, 'Uma não reativa'],
            [2, 'Nenhuma reativa'],
          ].map(([value, label]) => (
            <button key={value} type="button" className="key" aria-pressed={erp === value} onClick={() => setErp(value)}>
              <span className="key__lb">{label}</span>
              <span className="key__pt mono">{value}</span>
              <span className="key__ds">ERP {value}</span>
            </button>
          ))}
        </fieldset>

        <aside className="ecgp-result" aria-live="polite">
          <span>Resultado</span>
          <strong>{result}</strong>
          <p className="mono">ECG {gcs} − ERP {erp} = ECG-P {result}</p>
        </aside>
      </div>
    </section>
  );
}
